module.exports = __webpack_public_path__ + "static/media/AMV.3f35e9a3.svg";